import { styled } from "styled-components";

export const Container = styled.div`
  max-width: 800px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 900px;
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 100px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #333;
  width: 200px;
  padding-top: 10px;
`;

export const FileUpload = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  span {
    color: #666;
    font-size: 14px;
  }
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  span {
    color: #666;
    font-size: 14px;
  }
`;

export const PreviewImage = styled.div`
  width: 53px;
  
  height: 53px;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RemoveButton = styled.button`
  color: ${props => props.theme.colors.primary};
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 130px;
  margin-left: 300px;
  margin-top: 8px;
`;

export const DeleteButton = styled.button<{ disabled: boolean }>`
  color: ${props => props.theme.colors.danger};
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  padding: 10px 0;
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  &:hover {
    text-decoration: underline;
  }
  &:disabled {
    color: #ccc;
    cursor: default;
  }
`;
